import React, { useEffect, useState } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import SimpleTableDistance from "./SimpleTableDistance";
import SimpleTableStrength from "./SimpleTableStrength";
import SimpleTableTeams from "./SimpleTableTeams";

const April25 = () => {
  const [distanceData, setDistanceData] = useState([]);
  const [strengthData, setStrengthData] = useState([]);
  const [teamsData, setTeamsData] = useState([]);
  const [activeTab, setActiveTab] = useState("teams");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [distanceRes, strengthRes, teamsRes] = await Promise.all([
          Axios.get("/api/distance/"),
          Axios.get("/api/strength/"),
          Axios.get("/api/teams/"),
        ]);
        setDistanceData(distanceRes.data);
        setStrengthData(strengthRes.data);
        setTeamsData(teamsRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      paddingTop: "10vh",
      backgroundColor: "#f3f4f6",
    },
    heading: {
      fontSize: "2rem",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#1f2937",
    },
    tabs: {
      display: "flex",
      justifyContent: "center",
      gap: "15px",
      marginBottom: "20px",
    },
    tabButton: (isActive) => ({
      padding: "10px 20px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      backgroundColor: isActive ? "#2563eb" : "#e5e7eb",
      color: isActive ? "#fff" : "#000",
      fontWeight: "bold",
    }),
    box: {
      width: "400px",
      backgroundColor: "#fff",
      padding: "2.5rem",
      borderRadius: "1rem",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      textAlign: "center",
    },
    title: {
      fontSize: "1.5rem",
      fontWeight: "bold",
    },
    text: {
      color: "#4b5563",
    },
    infoIcon: {
      marginLeft: "8px",
      textDecoration: "none",
      fontSize: "1.2rem",
      color: "#007bff",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Dola Gi: Hunt Your Limits</h1>

      <div style={styles.tabs}>
        <button
          style={styles.tabButton(activeTab === "distance")}
          onClick={() => setActiveTab("distance")}
        >
          Distance
        </button>
        <button
          style={styles.tabButton(activeTab === "strength")}
          onClick={() => setActiveTab("strength")}
        >
          Strength
        </button>
        <button
          style={styles.tabButton(activeTab === "teams")}
          onClick={() => setActiveTab("teams")}
        >
          Teams
        </button>
      </div>

      <div style={styles.box}>
        {activeTab === "distance" && (
          <>
            <h2 style={styles.title}>Individual Distance Leaderboard</h2>
            <p style={styles.text}>2 Km</p>
            <SimpleTableDistance data={distanceData} />
          </>
        )}
        {activeTab === "strength" && (
          <>
            <h2 style={styles.title}>Individual Strength Leaderboard</h2>
            <p style={styles.text}>Squats</p>
            <SimpleTableStrength data={strengthData} />
          </>
        )}
        {activeTab === "teams" && (
          <>
            <p style={styles.text}>Final result for April 2025</p>
            <h2 style={styles.title}>
              Teams Leaderboard
              <Link to="/team-distribution" style={styles.infoIcon}>
                ℹ️
              </Link>
            </h2>
            <p style={styles.text}>
              Points Based
              <Link to="/rules_and_regulations" style={styles.infoIcon}>
                ℹ️
              </Link>
            </p>
            <SimpleTableTeams data={teamsData} />
          </>
        )}
      </div>
    </div>
  );
};

export default April25;

